export default {
  STARTS_AT: "Début",
  ENDS_AT: "Fin",
  COUNTER_SALES: "Ventes comptoir",
  BILLING: "Facturation",
  DISTRIBUTOR_SALES: "Ventes distributrice",
  COUNTER_PURCHASE: "Achat comptoir",
  STATIONERY: "Papeterie",
  CLEANING_AND_DISPOSABLE_PRODUCTS: "Produits nettoyants et jetables",
  OTHERS: "Autres",
  MAINTENANCE: "Entretien",
  DISTRIBUTOR: "Distributrice",
  WAGES: "Salaires",
  RENT: "Loyer",
  DISCOUNT: "Redevance",
  FIXED_AMOUNT: "Montant fixe",
  WITH_TAXES: "Avec taxes",
  WITHOUT_TAXES: "Sans taxes",
  NO_TAXES: "Sans taxes",
  WEEKLY_REPORTS_LIST: "Liste des rapports hebdomadaires",
  ADD_WEEKLY_REPORT: "Ajouter un rapport hebdomadaire",
  WEEKLY_REPORT_ADDED: "Rapport hebdomadaire ajouté",
  EDIT_WEEKLY_REPORT: "Modifier un rapport hebdomadaire",
  WEEKLY_REPORT_UPDATED: "Rapport hebdomadaire mis à jour",
  DELETE_THIS_WEEKLY_REPORT: "Supprimer ce rapport hebdomadaire ?",
  WEEKLY_REPORT_DELETED: "Rapport hebdomadaire supprimé",
  SALES: "Ventes",
  TITLE: "Rapports hebdomadaires",
  CREATE_REPORT: "Créer un rapport",
  REPORT_CREATED_SUCCESSFULLY: "Rapport hebdomadaire créé avec succès",
  REQUIRE_PREVIOUS_WEEK_REPORT: "Le rapport de la semaine précédente est requis",
  NO_WAREHOUSES_FOUND: "Aucun entrepôt trouvé pour cet établissement",
  UPLOAD_REPORT_FILE: "Téléverser un fichier de rapport",
  REPORT_FILE: "Fichier de rapport",
  SUPPORTED_FORMATS: "Formats pris en charge: Excel, CSV, PDF, Word",
  FILE_TOO_LARGE: "Le fichier est trop volumineux. La taille maximale est de 10 Mo.",
  FILE_REQUIRED: "Veuillez sélectionner un fichier de rapport",
  REPORT_UPLOADED_SUCCESSFULLY: "Rapport hebdomadaire téléversé avec succès",
  DOWNLOAD_REPORTS_ZIP: "Télécharger les rapports en ZIP",
  SELECT_DATE_RANGE: "Sélectionner la période",
  DOWNLOAD_STARTED: "Téléchargement en cours...",
  DOWNLOAD_COMPLETED: "Téléchargement terminé",
  CONFIRM_CREATE_TITLE: "Créer un rapport hebdomadaire",
  CONFIRM_CREATE_TEXT: "Êtes-vous sûr de vouloir créer un rapport hebdomadaire ?",
  CASH_REGISTER_READINGS: "Lectures de caisse",
  SALES_ORDERS: "Factures de vente",
  SALES_INVOICES: "Factures de vente",
  DATE_RANGE: "Période",
  NO_CASH_REGISTER_READINGS: "Aucune lecture de caisse pour cette période",
  NO_SALES_ORDERS: "Aucune facture de vente pour cette période",
  DAILY_SALES: "Détails",
  DAILY_SALES_SUMMARY: "Récapitulatif des ventes quotidiennes",
  WEEK_OF: "Semaine du",
  NO_SALES_DATA: "Aucune donnée de vente pour cette période",
  NO_DATA: "Aucune donnée",
  TOTAL_SALES: "Ventes totales",
  TOTAL_SALES_ORDERS: "Total des factures de vente",
  VENDING_MACHINE_SALES: "Ventes de distributrices",
  VENDING_MACHINE_SALES_AMOUNT: "Montant des ventes",
  VENDING_MACHINE_SALES_HELP: "Entrez le total des ventes des distributrices pour cette semaine",
  VENDING_MACHINE_SALES_UPDATED:
    "Ventes de distributrices mises à jour avec succès",
  UPDATE_VENDING_MACHINE_SALES: "Mettre à jour les ventes de distributrices",
  ACTUAL_RECEIVED_TOTAL: "Montant réellement reçu",
  COUPONS_TO_INVOICE_TOTAL: "Coupons à facturer (semaine)",
  COUPONS_TO_INVOICE_REMAINING: "Reste à facturer (coupons, cumulatif)",
  CASH_REGISTERS_SALES: "Ventes comptoir",
  INVOICING_SALES: "Facturations",
  SUBSIDIZED_SALES: "Aide-alimentaire",
  TOTAL_PURCHASES_ORDERS: "Total des factures d'achat",
  PURCHASES_ORDERS: "Factures d'achat",
  PURCHASES_INVOICES: "Factures d'achat",
  NO_PURCHASES_ORDERS: "Aucune facture d'achat pour cette période",
  ADD_NEW_LINE: "Ajouter une nouvelle ligne",
  PURCHASE_SUMMARY: "Résumé des achats",
  PURCHASE_TYPE: "Type d'achat",
  REGULAR_PURCHASES: "Achats réguliers",
  ADDITIONAL_PURCHASES: "Achats supplémentaires",
  TOTAL_PURCHASES: "Total achats",
  CONSUMABLES_PURCHASES_TOTAL: "Total achats comestibles",
  NET_PROFIT: "Bénéfice net",
  SALES_ORDERS: "Factures de vente",
  CASH_REGISTER_SUMMARY: "Résumé des lectures de caisse",
  TOTAL_SALES_ORDERS: "Total des factures de vente",
  ADD_NEW_SALES_LINE: "Ajouter une nouvelle ligne de vente",
  SALES_ORDERS_TOTAL: "Total des ventes",
  PURCHASE_ORDERS_TOTAL: "Total des factures d'achat",
  TRANSFER_IN: "Transferts entrants",
  TRANSFER_OUT: "Transferts sortants",
  TRANSFER_IN_WITH_TAXES: "Transferts entrants (taxes incluses)",
  TRANSFER_OUT_WITH_TAXES: "Transferts sortants (taxes incluses)",
  NO_TRANSFERS: "Aucun transfert pour cette période",
  NO_INTERNAL_INVOICES: "Aucune facture interne pour cette période",
  PURCHASES: "Achats",
  OTHER: "Charges",
  EXCERPT: "Commentaire du Chef-gérant",
  TOTAL_COSTS: "Charges",

  // Sources des calculs (infobulles)
  CALCULATION_SOURCE: "Source du calcul",
  SRC_DAILY_SALES:
    "Somme des ventes des lectures de caisse (Z) de la semaine. La colonne « Sans taxes » retire TPS + TVQ pour les universités et collèges.",
  SRC_ACTUAL_RECEIVED:
    "Somme des « Montant réellement reçu » des lectures de caisse de la semaine (encaisse − coupons), plus les coupons facturés durant la semaine (sous-total hors taxes des factures de coupons validées ou payées).",
  SRC_COUPONS_TOTAL:
    "Somme des « Coupon (À facturer) » saisis dans les lectures de caisse de la semaine.",
  SRC_COUPONS_REMAINING:
    "Cumul des coupons saisis dans les lectures de caisse depuis le début − cumul des factures de coupons validées ou payées, arrêté à la fin de la semaine.",
  SRC_INVOICING_SALES:
    "Sous-total des factures de vente validées ou payées dont la date de facturation est dans la semaine, plus les lignes de vente supplémentaires. Les factures de coupons sont exclues : leur montant est déjà compté dans les ventes comptoir.",
  SRC_INTERNAL_INVOICE_OUT:
    "Factures internes acceptées émises par cet établissement vers un autre établissement durant la semaine, après le rabais accordé par la cafétéria de production. Les factures internes ne sont pas taxées : les deux colonnes affichent donc le même montant.",
  SRC_VENDING_MACHINE_SALES:
    "Montant saisi manuellement (avec taxes). La valeur sans taxes est déduite pour les universités et collèges.",
  FORMULA_TOTAL_SALES:
    "Ventes comptoir {daily} + Facturations {invoicing} + Factures internes sortantes {internal} + Distributrices {vending} = {total}",
  SRC_PURCHASE_ORDERS_TOTAL:
    "Sous-total des factures d'achat validées ou payées dont la date de facturation est dans la semaine, plus les lignes d'achat supplémentaires.",
  SRC_TRANSFER_OUT:
    "Transferts acceptés envoyés par cet établissement durant la semaine (retirés des achats).",
  SRC_TRANSFER_IN:
    "Transferts acceptés reçus par cet établissement durant la semaine (ajoutés aux achats).",
  SRC_INTERNAL_INVOICE_IN:
    "Factures internes acceptées reçues d'un autre établissement durant la semaine, après le rabais accordé par la cafétéria de production (ajoutées aux achats). Les factures internes ne sont pas taxées : les deux colonnes affichent donc le même montant.",
  FORMULA_TOTAL_PURCHASES:
    "Factures d'achat {regular} + Transferts entrants {transferIn} − Transferts sortants {transferOut} + Factures internes entrantes {internalIn} = {total}",
  SRC_CONSUMABLES_PURCHASES:
    "Lignes des factures d'achat, des factures internes entrantes et des transferts entrants dont la catégorie de produit est « comestible », moins les transferts sortants comestibles (sans taxes).",
  SRC_WAGES:
    "Montant saisi. Avec taxes = salaires × 1,22 (22 % de charges salariales).",
  SRC_RENT:
    "Montant saisi ou calculé selon le type de loyer de l'établissement (montant fixe ou redevance). Aucune taxe appliquée.",
  FORMULA_TOTAL_COSTS: "Salaires {wages} + Loyer {rent} = {total}",
  FORMULA_NET_PROFIT:
    "Ventes totales {sales} − Total achats {purchases} − Charges {costs} = {total}",
  FORMULA_RATIO: "{label} {numerator} / Ventes totales {sales} = {ratio}",
  SRC_TARGET: "Objectif défini dans la fiche de l'établissement.",
  SRC_DIFFERENCE: "Résultat − Objectif.",
  SRC_NET_PROFIT_DIFFERENCE: "Bénéfice net − Objectif.",
  COUPON_INVOICE_EXCLUDED:
    "Facture de coupons : exclue des ventes totales, son montant est déjà compté dans les ventes comptoir. Elle fait passer le « Reste à facturer » vers le « Montant réellement reçu ».",
  COUPON_INVOICE_BADGE: "Coupons (exclue des ventes)",
  FILTER_BY_ESTABLISHMENT: "Filtrer par établissement",
  FILTER_BY_DATES: "Filtrer par dates",
  
  // Target Ratio Analysis
  TARGET_RATIO_ANALYSIS: "Analyse des ratios objectifs",
  WAGES_RATIO: "Ratio salaires",
  PURCHASES_RATIO: "Ratio achats",
  NET_PROFIT_RATIO: "Ratio profit net",
  TARGET: "Objectif",
  ACTUAL: "Réel",
  DIFFERENCE: "Différence",
  TARGET_REACHED: "Objectif atteint",
  ABOVE_TARGET: "Au-dessus de l'objectif",
  BELOW_TARGET: "En dessous de l'objectif",
  UNDER_TARGET: "Sous l'objectif",
  OVER_TARGET: "Au-dessus de l'objectif",
  RESULT: "Résultat",
  PURCHASES_CONSUMABLES: "Achats comestibles",
  SAVING: "Sauvegarde en cours",
  UNSAVED_CHANGES: "Modifications non enregistrées",
  PURCHASE_TOTAL: "Total des achats",
  INTERNAL_INVOICE_OUT: "Facture interne sortante",
  INTERNAL_INVOICE_IN: "Facture interne entrante",
  INTERNAL_INVOICE_IN_WITH_TAXES: "Facture interne entrante (taxes incluses)",
  INTERNAL_INVOICE_OUT_WITH_TAXES: "Facture interne sortante (taxes incluses)",
  REFRESH_CALCULATIONS: "Actualiser les calculs",
  CALCULATIONS_REFRESHED: "Calculs actualisés avec succès",

  // Validation
  VALIDATE_REPORT: "Valider le rapport",
  REVERT_TO_DRAFT: "Revenir en brouillon",
  WEEKLY_REPORT_VALIDATED: "Rapport hebdomadaire validé avec succès",
  WEEKLY_REPORT_REVERTED: "Rapport hebdomadaire remis en brouillon",
  VALIDATE_WARNING_TITLE: "Attention — Éléments ouverts",
  OPEN_ITEMS_WARNING: "Des éléments sont encore ouverts pour cette période :",
  OPEN_SALES_ORDERS_COUNT: "{count} commande(s) de vente ouverte(s)",
  OPEN_SALES_INVOICES_COUNT: "{count} facture(s) de vente ouverte(s)",
  OPEN_PURCHASES_ORDERS_COUNT: "{count} commande(s) d'achat ouverte(s)",
  OPEN_PURCHASES_INVOICES_COUNT: "{count} facture(s) d'achat ouverte(s)",
  OPEN_TRANSFERS_COUNT: "{count} transfert(s) ouvert(s)",
  OPEN_INTERNAL_INVOICES_COUNT: "{count} facture(s) interne(s) ouverte(s)",
  OPEN_CASH_REGISTER_READINGS_COUNT: "{count} lecture(s) de caisse ouverte(s)",
  RECOMMEND_CLOSE_ITEMS: "Il est recommandé de fermer ces éléments avant de valider le rapport.",
  VALIDATE_ANYWAY: "Valider quand même",
  VALIDATE_BLOCKED_TITLE: "Validation impossible — salaires manquants",
  WAGES_REQUIRED:
    "Les salaires de cette semaine sont à 0 $. Saisissez-les dans l'onglet « Détails » : le rapport ne peut pas être validé sans salaires.",
  CONFIRM_VALIDATE_TITLE: "Valider le rapport hebdomadaire",
  CONFIRM_VALIDATE_TEXT: "Êtes-vous sûr de vouloir valider ce rapport ? Une fois validé, il ne pourra plus être modifié.",
  CONFIRM_REVERT_TITLE: "Revenir en brouillon",
  CONFIRM_REVERT_TEXT: "Êtes-vous sûr de vouloir remettre ce rapport en brouillon ? Il pourra à nouveau être modifié.",
  REPORT_VALIDATED: "Validé",
  REPORT_DRAFT: "Brouillon",
  INTERNAL_INVOICE_PRODUCTS_RECEIVED: "Produits facturés en interne — reçus",
  INTERNAL_INVOICE_PRODUCTS_SENT: "Produits facturés en interne — envoyés",
  INTERNAL_INVOICE_PRODUCTS_HELP: "Uniquement les produits effectivement passés en facture interne acceptée. Un produit commandé mais non reçu n'apparaît pas. Les montants sont nets du rabais accordé par la cafétéria de production, comme les totaux du rapport.",
  INVOICES_COUNT: "Nb factures",
};
